export class TreeConstants {
    public static indicatorLevel: number = 1;
}